import { Component, OnInit } from '@angular/core';
import { FundingService } from '../../../../../../shared/services/funding.service';
import { NgxSpinnerService } from "ngx-spinner"; 

@Component({
    selector: 'app-onboarding-distribution',
    templateUrl: './distribution.component.html',
    styleUrls: ['./distribution.component.scss'],
})
export class DistributionComponent implements OnInit {
    localRange = 25;
    globalRange = 75;

    localValue: number;
    globalValue: number;

    usExchangeRate;
    defaultCurrency = 'USD';

    value = localStorage.advAmount;
    result: any;
    exchangeRate: any;

    inputChanged(e) {
        this.localRange = e.target.value;
        this.globalRange = 100 - this.localRange;
        this.calculateValues();
    }
    calculateValues() {
        if (this.defaultCurrency === 'USD') {
            this.localValue =
                (this.localRange / 100) * this.value * this.exchangeRate;
            this.globalValue = (this.globalRange / 100) * this.value;
        } else {
            this.localValue = (this.localRange / 100) * this.value;
            this.globalValue =
                ((this.globalRange / 100) * this.value) / this.usExchangeRate;
        }
    }
    constructor(private api: FundingService,
                private SpinnerService: NgxSpinnerService) {}


    ngOnInit() {
        // this.getTodayRate();
        this.calculateValues();

    }

    getTodayRate(){
        this.SpinnerService.show(); 
        this.api.rate()
            .subscribe((res:any)=>{
                this.exchangeRate =res.data.buy;
                this.usExchangeRate = res.data.sell;
                this.SpinnerService.hide(); 
            })
    }
}

